/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery, useQueryClient } from "react-query";

/**
 * Global state hook using React Query cache.
 * @param key unique cache key
 * @param value optional new value to set
 * @param initial default value if none in cache
 */
export function useGlobalState<T>(
  key: string,
  initial?: T
): [T | undefined, (v: T) => void] {
  const queryClient = useQueryClient();

  // Subscribe to this global state
  const { data } = useQuery<T>({
    queryKey: [key],
    queryFn: () => undefined as any, // no fetcher
    initialData: initial, // fallback if cache empty
  });

  // Setter
  const setValue = (v: T) => {
    queryClient.setQueryData([key], v);
  };

  return [data, setValue];
}
